// assets
import {
  IconBuildingFactory2,
  IconMapPin,
  IconWindmill,
  IconCloudStorm,
  IconDatabase,
  IconChartHistogram,
  IconChecklist,
  IconVariable,
  IconGauge,
  IconCalendarOff,
  IconChartLine,
  IconTrophy
} from '@tabler/icons-react';

// constant
const icons = {
  IconBuildingFactory2,
  IconMapPin,
  IconWindmill,
  IconCloudStorm,
  IconDatabase,
  IconChartHistogram,
  IconChecklist,
  IconVariable,
  IconGauge,
  IconCalendarOff,
  IconChartLine,
  IconTrophy
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Infrastructure',
      type: 'item',
      url: '/',
      icon: icons.IconBuildingFactory2,
      color: '#6366f1' // indigo
    },
    {
      id: 'locations',
      title: 'Locations',
      type: 'item',
      url: '/locations',
      icon: icons.IconMapPin,
      color: '#f43f5e' // rose
    },
    {
      id: 'turbines',
      title: 'Turbines',
      type: 'item',
      url: '/turbines',
      icon: icons.IconWindmill,
      color: '#14b8a6' // teal
    },
    {
      id: 'forecasts',
      title: 'Forecasts',
      type: 'item',
      url: '/forecasts',
      icon: icons.IconCloudStorm,
      color: '#0ea5e9' // sky
    },
    {
      id: 'sources',
      title: 'Sources',
      type: 'item',
      url: '/sources',
      icon: icons.IconDatabase,
      color: '#f59e0b' // amber
    },
    {
      id: 'comparison',
      title: 'Comparison',
      type: 'item',
      url: '/comparison',
      icon: icons.IconChartHistogram,
      color: '#8b5cf6' // violet
    },
    {
      id: 'validator-backtests',
      title: 'Validator Backtests',
      type: 'item',
      url: '/validator-backtests',
      icon: icons.IconChecklist,
      color: '#10b981' // emerald
    },
    {
      id: 'variables',
      title: 'Variables',
      type: 'item',
      url: '/variables',
      icon: icons.IconVariable,
      color: '#f97316' // orange
    },
    {
      id: 'variable-data',
      title: 'Variable Data',
      type: 'item',
      url: '/variable-data',
      icon: icons.IconChartLine,
      color: '#a855f7' // purple
    },
    {
      id: 'metrics',
      title: 'Accuracy Metrics',
      type: 'item',
      url: '/metrics',
      icon: icons.IconGauge,
      color: '#06b6d4' // cyan
    },
    {
      id: 'accuracy-ranking',
      title: 'Accuracy Ranking',
      type: 'item',
      url: '/accuracy-ranking',
      icon: icons.IconTrophy,
      color: '#eab308' // amber
    },
    {
      id: 'unavailabilities',
      title: 'Unavailabilities',
      type: 'item',
      url: '/unavailabilities',
      icon: icons.IconCalendarOff,
      color: '#ef4444' // red
    }
  ]
};

export default pages;
